import script from "./MessagingCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagingCenter.vue?vue&type=script&setup=true&lang=js"

import "./MessagingCenter.vue?vue&type=style&index=0&id=716c4557&scoped=true&lang=css"
import "./MessagingCenter.vue?vue&type=style&index=1&id=716c4557&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-716c4557"]])

export default __exports__